import Vue from "vue";
import i18n from "@/i18n";
import dayjs from "dayjs";
// Vue.filter('carNameDisplay', (name, brand) => {
//   let value = ''
//   if (brand) {
//     value = value + '(' + brand + ') '
//   }
//   if (name) {
//     value = value + name
//   }
//   return value
// })

Vue.filter("comma", (value) => {
  if (value) {
    const parts = value.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
  } else return 0;
});

Vue.filter("toFixed", (value, text) => {
  if (value) {
    return Number(value).toFixed(2);
  } else return text || 0;
});

Vue.filter("gender", (value) => {
  if (value === "M") return i18n.t("text.common.male");
  else return i18n.t("text.common.female");
});

Vue.filter("status", (status) => {
  if (status == 1) {
    return i18n.t("text.common.available");
  } else if (status == 2) {
    return i18n.t("text.common.unavailable");
  } else if (status == 3) {
    return i18n.t("text.common.in_use");
  }
});

Vue.filter("status2", (status) => {
  if (status == 1) {
    return i18n.t("text.common.available");
  } else if (status == 2) {
    return i18n.t("text.common.unavailable");
  } else {
    return i18n.t("text.common.in_use");
  }
});

Vue.filter("status3", (status) => {
  let s = "";
  switch (status) {
    case "1":
      s = i18n.t("text.common.ready");
      break;
    case "2":
      s = i18n.t("text.common.playing");
      break;
    case "3":
      s = i18n.t("text.common.move");
      break;
    case "4":
      s = i18n.t("text.common.terminated");
      break;
    case "5":
      s = i18n.t("text.common.drop");
      break;
    case "6":
      s = i18n.t("text.common.completed");
      break;
  }
  return s;
});

Vue.filter("score", (v) => {
  if (v === null) return "";
  if (v === 0) return "";
  return v;
});

Vue.filter("score2", (v) => {
  if (v == null) return "";
  if (v == 0) return "";
  return "(" + v + ")";
});

Vue.filter("get_custormer_category", (value) => {
  switch (value) {
    case "1":
      return i18n.t("button.common.notice");

    case "2":
      return i18n.t("text.common.as");

    case "3":
      return i18n.t("text.common.proposal");

    case "4":
      return i18n.t("text.common.etec");

    default:
      return i18n.t("text.common.total");
  }
});

Vue.filter("get_custormer_category_bg", (value) => {
  switch (value) {
    case "1":
      return "bg-purple";

    case "2":
      return "bg-orange";

    case "3":
      return "bg-teal";

    case "4":
      return "bg-dark";

    default:
      return "total";
  }
});

Vue.filter("get_club_type", (value) => {
  switch (value) {
    case "1":
      return i18n.t("text.common.driver");

    case "2":
      return i18n.t("text.common.wood");

    case "3":
      return i18n.t("text.common.utility");

    case "4":
      return i18n.t("text.common.iron");

    case "5":
      return i18n.t("text.common.wedge");

    case "6":
      return i18n.t("text.common.putter");
  }
});

Vue.filter("get_shaft_material", (value) => {
  switch (value) {
    case "1":
      return i18n.t("text.common.graphite");

    case "2":
      return i18n.t("text.common.steel");

    case "3":
      return i18n.t("text.common.carbon");
    default:
      return "-";
  }
});

Vue.filter("get_state_cd", (value) => {
  switch (value) {
    case "1":
      return i18n.t("text.common.shipping_wait");

    case "2":
      return i18n.t("text.common.shipping_in_progress");

    case "3":
      return i18n.t("text.common.shipping_completed");
    default:
      return "-";
  }
});

Vue.filter("get_balance", (value) => {
  switch (value) {
    case "1":
      return "R";

    case "2":
      return "SR";

    case "3":
      return "S";

    case "4":
      return "L";
    default:
      return "-";
  }
});

Vue.filter("get_interestclub", (value) => {
  switch (value) {
    case "1":
      return i18n.t("text.common.sense_of_shot");

    case "2":
      return i18n.t("text.common.sense_of_direction");

    case "3":
      return i18n.t("text.common.sense_of_distance");
  }
});

Vue.filter("set_bracket", (value) => {
  if (value) {
  }
  return;
});

Vue.filter("get_img", (value) => {
  if (value) {
    return process.env.VUE_APP_S3_BUCKET_URL + "/" + value;
  } else {
    return "/img/no-img.png";
  }
});

Vue.filter("get_club_code", (value) => {
  switch (value) {
    case "1":
      return "DR";

    case "2":
      return "W2";

    case "3":
      return "I3";

    case "4":
      return "U4";

    case "5":
      return "PW";

    case "6":
      return "AW";

    default:
      return "ETC";
  }
});

Vue.filter("get_lesson_title", (value) => {
  switch (value) {
    case "lesson1":
      return "Address";

    case "lesson2":
      return "Back Swing";

    case "lesson3":
      return "Top Swing";

    case "lesson4":
      return "Down Swing";

    case "lesson5":
      return "Impact";

    case "lesson6":
      return "Follow Through";

    case "lesson7":
      return "Finish";

    case "lessontotal":
      return "Total";
  }
});

Vue.filter("teeboxType", (teebox) => {
  if (teebox === "1") {
    return i18n.t("text.common.pro") + "(" + i18n.t("text.common.blue") + ")";
  } else if (teebox === "2") {
    return (
      i18n.t("text.common.regular") + "(" + i18n.t("text.common.white") + ")"
    );
  } else if (teebox === "3") {
    return i18n.t("text.common.lady") + "(" + i18n.t("text.common.red") + ")";
  } else if (teebox === "4") {
    return (
      i18n.t("text.common.senior") + "(" + i18n.t("text.common.yellow") + ")"
    );
  } else {
    return i18n.t("text.common.none");
  }
});

Vue.filter("dateformat", (value, type) => {
  if (value) {
    if (type) return dayjs(value).format(type);
    else return dayjs(value).format("YYYY.MM.DD");
  } else {
    return "-";
  }
});

Vue.filter("transToValue", (value, text) => {
  if (value == "0") {
    return text;
  } else return value;
});

Vue.filter("suffix", (value, text) => {
  if (value == "0" || !value) {
    return "-";
  } else return value + text;
});

Vue.filter("greenspeed", (status) => {
  let s = "-";
  switch (status) {
    case "1":
      s = i18n.t("title.common.veryfast");
      break;
    case "2":
      s = i18n.t("title.common.fast");
      break;
    case "3":
      s = i18n.t("title.common.normal");
      break;
    case "4":
      s = i18n.t("title.common.slow");
      break;
    case "5":
      s = i18n.t("title.common.veryslow");
      break;
  }
  return s;
});
Vue.filter("greengravity", (status) => {
  let s = "-";
  switch (status) {
    case "1":
      s = i18n.t("title.common.veryfast");
      break;
    case "2":
      s = i18n.t("title.common.fast");
      break;
    case "3":
      s = i18n.t("title.common.normal");
      break;
    case "4":
      s = i18n.t("title.common.slow");
      break;
    case "5":
      s = i18n.t("title.common.veryslow");
      break;
  }
  return s;
});
